import React, { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [rolePermissionList, setRolePermissionList] = useState(() => {
    const saved = localStorage.getItem("rolePermissionList");
    return saved ? JSON.parse(saved) : [];
  });
  const [userType, setUserType] = useState(() => {
    return localStorage.getItem("userType") || "";
  });

  const [assetFilters, setAssetFilters] = useState({});

  const DEFAULT_LISTING_COLUMNS = [
    { label: "S.No", status: true, value: "s_no" },
    { label: "Code", status: false, value: "code" },
    { label: "Name", status: true, value: "name" },
    { label: "Type", status: true, value: "asset_type" },
    { label: "Serial No", status: false, value: "serial_number" },
    { label: "Invoice no", status: false, value: "invoice_number" },
    { label: "Tag", status: true, value: "asset_tag" },
    { label: "Location", status: true, value: "location" },
    { label: "Assigned To", status: true, value: "assigned_to" },
    { label: "Managed By", status: false, value: "asset_managed_by" },
    { label: "Status", status: true, value: "asset_status" },
  ];

  const [listingColumns, setListingColumns] = useState(DEFAULT_LISTING_COLUMNS);

  return (
    <GlobalContext.Provider
      value={{
        rolePermissionList,
        setRolePermissionList,
        userType,
        setUserType,
        assetFilters,
        setAssetFilters,
        listingColumns,
        setListingColumns,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobal must be used within a GlobalProvider");
  }
  return context;
};
